var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.platFormTitle,
            visible: _vm.dialogFormVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents1" },
            [
              _c(
                "el-form",
                {
                  ref: "platForm",
                  attrs: {
                    model: _vm.platForm,
                    rules: _vm.rules,
                    "label-width": "auto",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          placeholder: "请输入活动名称",
                        },
                        model: {
                          value: _vm.platForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.platForm, "name", $$v)
                          },
                          expression: "platForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传文件", prop: "file" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            action: `${_vm.BASE.PRO1}/activity/product/import`,
                            headers: { token: _vm.token },
                            data: {
                              activity_id: _vm.platForm.activity_id,
                              template_content_id:
                                _vm.platForm.template_content_id,
                            },
                            accept: ".xlsx",
                            "on-success": _vm.successFile,
                            "on-error": _vm.errorFile,
                            "before-remove": _vm.beforeRemove,
                            "on-exceed": _vm.onExceed,
                            "on-change": _vm.onChange,
                            multiple: false,
                            limit: 1,
                            "auto-upload": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "选择分区", prop: "template_content_id" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择分区" },
                          model: {
                            value: _vm.platForm.template_content_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.platForm, "template_content_id", $$v)
                            },
                            expression: "platForm.template_content_id",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.region_name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.downloadFile },
                    },
                    [_vm._v("下载模版")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitFrom },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }